// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"3b53517f","54":"3b53517f","194":"3b53517f","423":"3b53517f","436":"3b53517f","569":"3b53517f","673":"3b53517f"}[chunkId] + ".chunk.css";
};